import { BcfAppId, BcfReleaseVersion } from '@bcf-v2-configurators/tokens/app/types';
import { crashLoggerUrl } from '@bcf-vanilla-ts-v1-shared/misc/crash-logger/constants';
import { ErrorCandidate } from './extractors';
import { ErrorPrepared, getErrorPrepared } from './get-error-prepared';

export type NgErrorReportingEnviroment = 'ng-production-browser' | 'ng-production-worker' | 'ng-production-server';

function stringifyPayload(bodyPayload: Record<string, any>): string {
  try {
    return JSON.stringify(bodyPayload);
  } catch (err) {
    const newPayload: Record<string, any> = {
      ...bodyPayload,
      rawError: undefined
    };
    return JSON.stringify(newPayload);
  }
}

async function sendError(
  bcfAppId: BcfAppId,
  bcfReleaseVersion: BcfReleaseVersion,
  preparedError: ErrorPrepared | ErrorCandidate,
  url: string | undefined,
  cookies: Record<string, string>,
  environment: NgErrorReportingEnviroment
): Promise<void> {
  // if (rawError instanceof HttpErrorResponse && [401, 404, 403, 0, 504].includes(rawError.status)) {
  //   return;
  // }
  const bodyPayload: Record<string, any> = {
    appId: bcfAppId,
    version: bcfReleaseVersion,
    url: url,
    error: preparedError,
    cookies: cookies,
    environment: environment
  };
  try {
    const crashUrl: string = `${crashLoggerUrl}error-reporting/`;
    // const crashUrl: string = `http://localhost:3005/error-reporting/`;
    await fetch(crashUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: stringifyPayload(bodyPayload)
    });
  } catch (err) {}
  return undefined;
}

export async function sendToErrorReporting(
  bcfAppId: BcfAppId,
  bcfReleaseVersion: BcfReleaseVersion,
  error: Error | undefined,
  url: string | undefined,
  cookies: Record<string, string>,
  environment: NgErrorReportingEnviroment
): Promise<void> {
  try {
    const preparedError: ErrorPrepared | undefined = getErrorPrepared(error);
    if (!preparedError) {
      return;
    }
    if (error?.stack?.includes('boarm.') || error?.stack?.includes('boaftp.')) {
      // external script (bet-on-action) that crash our gae-crash-logger
      return;
    }
    if (error?.stack?.includes('googletagmanager')) {
      return;
    }
    if (error?.stack?.includes('rezync.com')) {
      return;
    }

    sendError(bcfAppId, bcfReleaseVersion, preparedError, url, cookies, environment);
  } catch (err) {}
}

export async function sendToErrorUnhandledReporting(
  bcfAppId: BcfAppId,
  bcfReleaseVersion: BcfReleaseVersion,
  preparedError: ErrorCandidate | undefined,
  url: string | undefined,
  cookies: Record<string, string>,
  environment: NgErrorReportingEnviroment
): Promise<void> {
  try {
    if (!preparedError) {
      return;
    }

    sendError(bcfAppId, bcfReleaseVersion, preparedError, url, cookies, environment);
  } catch (err) {}
}
